"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _exchangeUiPortalsStore = require("@mulesoft/exchange-ui-portals-store");
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var eventsUtils = _interopRequireWildcard(require("../../../utils/events"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var tooltipStyles = {
  "tooltip-wrap": "Tooltip__tooltip-wrap__h_QN5",
  "tooltipWrap": "Tooltip__tooltip-wrap__h_QN5",
  "tooltip-text": "Tooltip__tooltip-text__2Idfx",
  "tooltipText": "Tooltip__tooltip-text__2Idfx"
}; 
require('../Tooltip.css');
var styles = {
  "asset-menu-action": "ActionAssetItem__asset-menu-action__1wmM7",
  "assetMenuAction": "ActionAssetItem__asset-menu-action__1wmM7",
  "label": "ActionAssetItem__label__3Nv--"
}; 
require('./ActionAssetItem.css');
var ActionAssetItem = function ActionAssetItem(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className,
    href = _ref.href,
    iconClassName = _ref.iconClassName,
    icon = _ref.icon,
    label = _ref.label,
    description = _ref.description,
    testId = _ref.testId,
    disclaimer = _ref.disclaimer,
    showIcon = _ref.showIcon,
    tooltip = _ref.tooltip;
  var isPortalReArchitectureEnabled = (0, _reactRedux.useSelector)(_exchangeUiPortalsStore.selectors.selectIsPIRAEnabled);
  var displayIcon = icon && (showIcon || !isPortalReArchitectureEnabled);
  var innerClassName = displayIcon ? (0, _classnames.default)(className, styles.assetMenuAction) : className;
  var itemLabel = [displayIcon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: iconClassName,
    size: "s",
    key: "icon",
    isDecorative: true
  }, icon) : null, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)((0, _defineProperty2.default)({}, styles.label, displayIcon)),
    key: "span"
  }, label)];
  if (href) {
    var _innerElement = /*#__PURE__*/_react.default.createElement("a", {
      "data-test-id": testId,
      "aria-describedby": "".concat(testId, "-description"),
      className: innerClassName,
      onClick: onClick,
      href: href,
      target: "_blank",
      rel: "noopener noreferrer"
    }, itemLabel, disclaimer);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tooltip ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      content: tooltip,
      position: "left",
      theme: tooltipStyles
    }, _innerElement) : _innerElement, description && /*#__PURE__*/_react.default.createElement("span", {
      id: "".concat(testId, "-description"),
      className: "visually-hidden"
    }, description));
  }
  var innerElement = /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": testId,
    role: "button",
    "aria-describedby": "".concat(testId, "-description"),
    "aria-label": typeof label === 'string' ? label : null,
    className: innerClassName,
    tabIndex: onClick ? 0 : -1,
    onClick: onClick,
    onKeyDown: eventsUtils.onEnterKey(onClick)
  }, itemLabel);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tooltip ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: tooltip,
    position: "left",
    theme: tooltipStyles
  }, innerElement) : innerElement, description && /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(testId, "-description"),
    className: "visually-hidden"
  }, description));
};
ActionAssetItem.defaultProps = {
  onClick: null,
  disclaimer: null,
  href: null,
  description: null,
  className: null,
  tooltip: null,
  iconClassName: null,
  showIcon: true
};
var _default = exports.default = ActionAssetItem;
//# sourceMappingURL=ActionAssetItem.js.map